import { render, staticRenderFns } from "./gc-decimal-cell.vue?vue&type=template&id=054cdd4a&scoped=true"
import script from "./gc-decimal-cell.vue?vue&type=script&lang=js"
export * from "./gc-decimal-cell.vue?vue&type=script&lang=js"
import style0 from "./gc-decimal-cell.vue?vue&type=style&index=0&id=054cdd4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054cdd4a",
  null
  
)

export default component.exports